import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { EXTERNAL_STYLES, GLOBAL_STYLES } from 'src/styles';

function append(shadowRoot: ShadowRoot, element: HTMLElement): void {
  if (shadowRoot.firstChild) {
    shadowRoot.insertBefore(element, shadowRoot.firstChild);
  } else {
    shadowRoot.appendChild(element);
  }
}

/**
 * Requires component to have set encapsulation to ViewEncapsulation.ShadowDom.
 */
@Directive({ standalone: true })
export class ShadowStylesDirective implements AfterViewInit {
  private readonly globalStyles: string = inject(GLOBAL_STYLES);
  private readonly externalStyles: string[] = inject(EXTERNAL_STYLES);
  private readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);

  public ngAfterViewInit(): void {
    const gloablStylesElement: HTMLStyleElement = document.createElement('style');
    gloablStylesElement.innerHTML = this.globalStyles;
    const shadowRoot: ShadowRoot | null = this.elementRef.nativeElement?.shadowRoot;

    if (!shadowRoot) {
      throw new Error(
        'Shadow root not present. Component maybe does not have required encapsulation: ViewEncapsulation.ShadowDom.'
      );
    }

    const externalStyleElements: HTMLLinkElement[] = this.externalStyles.map(styleUrl => {
      const element: HTMLLinkElement = document.createElement('link');
      element.rel = 'stylesheet';
      element.href = styleUrl;

      return element;
    });

    append(shadowRoot, gloablStylesElement);

    for (const externalStyleElement of externalStyleElements) {
      append(shadowRoot, externalStyleElement);
    }
  }
}
